import React from "react";
import Logo from "../../img/loginLogo.png";

import { Button, Fade, Grid, IconButton, Typography } from "@material-ui/core";

import Countdown from "react-countdown";
import {
  validationSchema,
  initialValue,
} from "../../validation/LoginGetOTPValidation";

import { connect } from "react-redux";
import { Form, Formik } from "formik";
import {
  confirm_forget,
  recoverPassWord,
} from "../../redux/Login/LoginActions";
import Store from "../../redux/Store";
import {
  authUnauthorizedMessage,
  setResetCaptcha,
} from "../../redux/Login/LoginActionCreators";
import TextFieldWrapper from "../../components/TextField";
import { Refresh } from "@material-ui/icons";
import Captcha from "../../components/Captcha";

const LoginGetCode = ({ recoverLoginContact, authError, resetCaptcha }) => {
  const timer = 2 * 60 * 1000;

  let time = Date.now() + timer;

  React.useEffect(() => {
    Store.dispatch(authUnauthorizedMessage(""));
  }, []);

  const handleReset = () => {
    Store.dispatch(setResetCaptcha(resetCaptcha + 1));
    recoverPassWord({ username: recoverLoginContact });
  };

  let [open, setOpen] = React.useState(false);

  React.useLayoutEffect(() => {
    setOpen(true);

    return () => {
      setOpen(false);
    };
  }, []);
  const Renderer = ({ minutes, seconds, completed }) => {
    if (completed) {
      return (
        <Completionist username={recoverLoginContact} handler={handleReset} />
      );
    } else {
      return (
        <Typography variant="body1" color="secondary">
          {minutes}:{seconds}
        </Typography>
      );
    }
  };

  return (
    <>
      <Formik
        initialValues={initialValue}
        validationSchema={validationSchema}
        validateOnMount
        onSubmit={(value, props) => {
          props.resetForm();

          confirm_forget(value);
        }}
      >
        {(formik) => {
          return (
            <Form>
              <Fade in={open} timeout={500}>
                <Grid
                  container
                  justifyContent="center"
                  alignItems="center"
                  style={{ height: "100vh", backgroundColor: "#F2F2F6" }}
                >
                  <Grid
                    container
                    item
                    justifyContent="center"
                    spacing={4}
                    xs={10}
                    sm={6}
                    md={5}
                    lg={4}
                    xl={3}
                    style={{
                      backgroundColor: "white",
                      borderRadius: "20px",
                      boxShadow: "0 3px 6px rgba(0,0,0,0.1)",
                      paddingTop: "51px",
                      paddingBottom: "51px",
                    }}
                  >
                    <Grid
                      item
                      md={10}
                      xs={12}
                      container
                      justifyContent="center"
                      spacing={3}
                    >
                      <Grid item xs={12} container justifyContent="center">
                        <img src={Logo} alt="logo" />
                      </Grid>
                      <Grid item xs={12} container justifyContent="center">
                        <Typography color="textSecondary" variant="subtitle1">
                          رمز درخواستی به{" "}
                          {isNaN(recoverLoginContact)
                            ? " آدرس ایمیل "
                            : " شماره موبایل "}
                          زیر ارسال شد
                        </Typography>
                      </Grid>
                      <Grid item xs={12} container justifyContent="center">
                        <Typography variant="button" color="secondary">
                          {recoverLoginContact}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} container justifyContent="center">
                        <Typography variant="button" color="secondary">
                          {authError}
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <TextFieldWrapper name="temp_token" label="رمز ورود" />
                      </Grid>

                      <Grid item container justifyContent="center">
                        <Countdown
                          date={time}
                          renderer={Renderer}
                          key={resetCaptcha}
                        />
                      </Grid>

                      <Grid item xs={12}>
                        <Button
                          disabled={!formik.isValid}
                          fullWidth
                          variant="contained"
                          color="primary"
                          type="submit"
                        >
                          تایید{" "}
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Fade>
            </Form>
          );
        }}
      </Formik>
    </>
  );
};

const mapStateToProps = (props) => {
  const { loginReducer } = props;
  const { recoverLoginContact, authError, captchaCode, resetCaptcha } =
    loginReducer;
  return { recoverLoginContact, authError, captchaCode, resetCaptcha };
};

export default connect(mapStateToProps)(LoginGetCode);
const Completionist = ({ username, handler }) => (
  <>
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Typography
        variant="body1"
        color="textSecondary"
        style={{ paddingBottom: "20px" }}
      >
        برای ادامه دوباره درخواست رمز کنید
      </Typography>
      <Captcha handler={handler} username={username} />

      <IconButton
        color="primary"
        disabled
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <Refresh color="primary" />
      </IconButton>
    </div>
  </>
);
